import React from 'react';
import styles from './DatasourceV2.module.scss';

// Small status line under a v2 widget: loading, failed, truncated or refreshing data
function DatasourceV2Notice({ status, truncated, rowCount, meta }) {
  let message = null;
  if (status === 'loading') message = I18n.t('datasource_v2_loading');
  else if (status === 'failed' || status === 'error') message = I18n.t('datasource_v2_failed');
  else if (truncated) message = I18n.t('datasource_v2_truncated', { count: rowCount });
  else if (meta?.refreshing && meta?.stale) message = I18n.t('datasource_v2_stale');

  if (!message) return null;

  return <div className={styles.notice} role='status'>{message}</div>;
}

export default DatasourceV2Notice;
